export default "__VITE_ASSET__C5z59hkm__"